import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrial: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trial, try, money-back, test-phase"><path d="M8.25 13.75V18.25H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.8853 20.4717C29.0751 10.8133 18.2184 -1.14597 11.8853 5.29361C6.14683 -0.541277 -3.3055 8.7295 7.7577 17.7071" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconTrial;
